"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _nanoid = require("nanoid");
const _globals = require("~/utils/globals");
const nanoidWorkspace = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 7);
const up = async (knex)=>{
    // fix base types
    await knex(_globals.MetaTable.PROJECT).update({
        type: 'database'
    }).whereNull('type');
    // check if there are any records in workspace table
    const workspaceCount = await knex(_globals.MetaTable.WORKSPACE).count('id', {
        as: 'count'
    }).first();
    if (!workspaceCount || +workspaceCount.count > 0) {
        return;
    }
    // find super user
    const superUser = await knex(_globals.MetaTable.USERS).where('roles', 'like', '%super%').first();
    // if no super user exists (no users created yet), skip workspace creation
    // workspace will be created when first user is created
    if (!superUser) {
        const userCount = await knex(_globals.MetaTable.USERS).count('id', {
            as: 'count'
        }).first();
        if (!userCount || +userCount.count === 0) {
            return;
        }
        throw new Error('No super user found in the system, cannot create default workspace');
    }
    const defaultWorkspaceId = `w${nanoidWorkspace()}`;
    // create workspace
    await knex(_globals.MetaTable.WORKSPACE).insert({
        id: defaultWorkspaceId,
        title: 'Default Workspace',
        fk_user_id: superUser.id,
        status: 1,
        plan: 'free',
        fk_org_id: null
    });
    const workspace = await knex(_globals.MetaTable.WORKSPACE).where('id', defaultWorkspaceId).first();
    // create workspace user
    await knex(_globals.MetaTable.WORKSPACE_USER).insert({
        fk_workspace_id: workspace.id,
        fk_user_id: superUser.id,
        roles: _nocodbsdk.WorkspaceUserRoles.OWNER
    });
    // update all records with fk_workspace_id
    const tables = [
        _globals.MetaTable.PROJECT,
        _globals.MetaTable.MODEL_STAT,
        _globals.MetaTable.API_TOKENS,
        _globals.MetaTable.AUDIT,
        _globals.MetaTable.PROJECT_USERS,
        _globals.MetaTable.CALENDAR_VIEW_COLUMNS,
        _globals.MetaTable.CALENDAR_VIEW,
        _globals.MetaTable.COLUMNS,
        _globals.MetaTable.EXTENSIONS,
        _globals.MetaTable.FILTER_EXP,
        _globals.MetaTable.FORM_VIEW_COLUMNS,
        _globals.MetaTable.FORM_VIEW,
        _globals.MetaTable.GALLERY_VIEW_COLUMNS,
        _globals.MetaTable.GALLERY_VIEW,
        _globals.MetaTable.GRID_VIEW_COLUMNS,
        _globals.MetaTable.GRID_VIEW,
        _globals.MetaTable.HOOK_TRIGGER_FIELDS,
        _globals.MetaTable.HOOK_LOGS,
        _globals.MetaTable.HOOKS,
        _globals.MetaTable.KANBAN_VIEW_COLUMNS,
        _globals.MetaTable.KANBAN_VIEW,
        _globals.MetaTable.MAP_VIEW_COLUMNS,
        _globals.MetaTable.MAP_VIEW,
        _globals.MetaTable.MODELS,
        _globals.MetaTable.SORT,
        _globals.MetaTable.SOURCES,
        _globals.MetaTable.SYNC_LOGS,
        _globals.MetaTable.SYNC_SOURCE,
        _globals.MetaTable.VIEWS,
        _globals.MetaTable.MODEL_ROLE_VISIBILITY,
        _globals.MetaTable.COMMENTS,
        _globals.MetaTable.COMMENTS_REACTIONS,
        _globals.MetaTable.USER_COMMENTS_NOTIFICATIONS_PREFERENCE,
        _globals.MetaTable.CALENDAR_VIEW_RANGE,
        _globals.MetaTable.COL_BARCODE,
        _globals.MetaTable.COL_FORMULA,
        _globals.MetaTable.COL_LOOKUP,
        _globals.MetaTable.COL_QRCODE,
        _globals.MetaTable.COL_RELATIONS,
        _globals.MetaTable.COL_ROLLUP,
        _globals.MetaTable.COL_SELECT_OPTIONS,
        _globals.MetaTable.WORKSPACE_USER,
        _globals.MetaTable.SNAPSHOT,
        _globals.MetaTable.CUSTOM_URLS,
        _globals.MetaTableOldV2.SCRIPTS,
        _globals.MetaTable.JOBS,
        _globals.MetaTable.FILE_REFERENCES,
        _globals.MetaTable.INTEGRATIONS,
        _globals.MetaTable.INTEGRATIONS_STORE,
        _globals.MetaTable.COL_LONG_TEXT,
        _globals.MetaTable.DATA_REFLECTION,
        _globals.MetaTable.COL_BUTTON,
        _globals.MetaTable.SYNC_CONFIGS,
        _globals.MetaTable.DASHBOARDS,
        _globals.MetaTable.MCP_TOKENS,
        _globals.MetaTable.WIDGETS,
        _globals.MetaTable.SNAPSHOT,
        _globals.MetaTable.ROW_COLOR_CONDITIONS
    ];
    for (const table of tables){
        await knex(table).update({
            fk_workspace_id: defaultWorkspaceId
        });
    }
    // add other users to workspace as NO_ACCESS
    const users = await knex(_globals.MetaTable.USERS).whereNot('id', superUser.id);
    for (const user of users){
        await knex(_globals.MetaTable.WORKSPACE_USER).insert({
            fk_workspace_id: workspace.id,
            fk_user_id: user.id,
            roles: (user == null ? void 0 : user.roles) === _nocodbsdk.OrgUserRoles.CREATOR ? _nocodbsdk.WorkspaceUserRoles.CREATOR : _nocodbsdk.WorkspaceUserRoles.NO_ACCESS
        });
    }
    await knex(_globals.MetaTable.STORE).insert({
        key: _globals.NC_STORE_DEFAULT_WORKSPACE_ID_KEY,
        value: defaultWorkspaceId
    });
};
const down = async (_knex)=>{
    throw new Error('Not implemented');
};
